/**
 * App-relative absolute path only. Rejects absolute URLs (`https://…`),
 * protocol-relative URLs (`//…`), and non-rooted values so untrusted input
 * can't become an open redirect through `router.push` / `Link`.
 */
export function isInAppPath(value: unknown): value is string {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')
}

/**
 * Normalize an app route to match Next's `trailingSlash: true` convention.
 * Query strings are preserved; the pathname segment gains a trailing slash.
 */
export function normalizeAppPath(path: string): string {
  const queryIndex = path.indexOf('?')
  const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex)
  const search = queryIndex === -1 ? '' : path.slice(queryIndex)
  if (pathname === '/') return `${pathname}${search}`
  const normalizedPathname = pathname.endsWith('/') ? pathname : `${pathname}/`
  return `${normalizedPathname}${search}`
}
